import { useEffect, useState } from 'react';

import { THEME } from '@/common/styles/theme';

const MOBILE_MEDIA_QUERY = `(max-width: ${THEME.mobileBreakpoint})`;

const resolveBannerSrc = (banner, isMobile) =>
	isMobile ? banner.mobileSrc : banner.desktopSrc;

export const useActiveBannerLayout = (banners, activeIndex) => {
	const [isMobile, setIsMobile] = useState(false);
	const [aspectRatio, setAspectRatio] = useState(null);

	const activeBanner = banners[activeIndex];

	useEffect(() => {
		const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);

		const syncViewport = () => setIsMobile(mediaQuery.matches);
		syncViewport();

		mediaQuery.addEventListener('change', syncViewport);
		return () => mediaQuery.removeEventListener('change', syncViewport);
	}, []);

	useEffect(() => {
		if (!activeBanner) {
			setAspectRatio(null);
			return undefined;
		}

		let cancelled = false;
		const image = new Image();
		const src = resolveBannerSrc(activeBanner, isMobile);

		image.onload = () => {
			if (cancelled || !image.naturalWidth || !image.naturalHeight) {
				return;
			}

			setAspectRatio(image.naturalWidth / image.naturalHeight);
		};

		image.onerror = () => {
			if (!cancelled) {
				setAspectRatio(null);
			}
		};

		image.src = src;

		return () => {
			cancelled = true;
		};
	}, [activeBanner, isMobile]);

	return {
		aspectRatio,
	};
};
